import React from 'react';

const formatNumber = (num) => {
    return new Intl.NumberFormat('en-US').format(num || 0);
};

const FeatureStats = ({ data, loading }) => {
    if (loading) {
        return (
            <div className="d-flex justify-content-center my-4">
                <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading stats...</span>
                </div>
            </div>
        );
    }

    if (!data) return null;

    return (
        <div className="audit-stats-container">
            {/* ROW 1: Key Metrics */}
            <div className="audit-stats-row1" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px' }}>
                <div className="audit-stats-card" style={{ backgroundColor: '#f0f9ff', border: '1px solid #e0f2fe' }}>
                    <div className="stats-icon primary-bg">
                        <i className="fa fa-file-alt"></i>
                    </div>
                    <div className="stats-content">
                        <div className="stats-label">Total Logs</div>
                        <div className="stats-value" style={{ fontSize: '24px', fontWeight: 700 }}>
                            {formatNumber(data.total)}
                        </div>
                    </div>
                </div>

                <div className="audit-stats-card" style={{ backgroundColor: '#f5f3ff', border: '1px solid #ede9fe' }}>
                    <div className="stats-icon info-bg">
                        <i className="fa fa-star"></i>
                    </div>
                    <div className="stats-content">
                        <div className="stats-label">Most Used Feature</div>
                        <div className="stats-value" style={{ textTransform: 'capitalize' }}>
                            {data.mostUsedFeature || 'N/A'}
                        </div>
                    </div>
                </div>

                <div className="audit-stats-card" style={{ backgroundColor: '#f0fdf4', border: '1px solid #dcfce7' }}>
                    <div className="stats-icon success-bg">
                        <i className="fa fa-check-circle"></i>
                    </div>
                    <div className="stats-content">
                        <div className="stats-label">Most Success Feature</div>
                        <div className="stats-value" style={{ textTransform: 'capitalize' }}>
                            {data.mostSuccessFeature || 'N/A'}
                        </div>
                    </div>
                </div>

                <div className="audit-stats-card" style={{ backgroundColor: '#fef2f2', border: '1px solid #fee2e2' }}>
                    <div className="stats-icon danger-bg">
                        <i className="fa fa-times-circle"></i>
                    </div>
                    <div className="stats-content">
                        <div className="stats-label">Most Failed Feature</div>
                        <div className="stats-value" style={{ textTransform: 'capitalize' }}>
                            {data.mostFailedFeature || 'N/A'}
                        </div>
                    </div>
                </div>

                <div className="audit-stats-card" style={{ backgroundColor: '#fff7ed', border: '1px solid #ffedd5' }}>
                    <div className="stats-icon warning-bg">
                        <i className="fa fa-envelope-open"></i>
                    </div>
                    <div className="stats-content">
                        <div className="stats-label">Most Opened Feature</div>
                        <div className="stats-value" style={{ textTransform: 'capitalize' }}>
                            {data.mostOpenedFeature || 'N/A'}
                        </div>
                    </div>
                </div>

                <div className="audit-stats-card" style={{ backgroundColor: '#f8fafc', border: '1px solid #f1f5f9' }}>
                    <div className="stats-icon secondary-bg">
                        <i className="fa fa-ban"></i>
                    </div>
                    <div className="stats-content">
                        <div className="stats-label">Most Dismissed Feature</div>
                        <div className="stats-value" style={{ textTransform: 'capitalize' }}>
                            {data.mostDismissedFeature || 'N/A'}
                        </div>
                    </div>
                </div>
            </div>

            {/* ROW 2: Status Breakdown */}
            <div style={{ marginTop: '5px', border: '1px solid #e2e8f0', padding: '20px', borderRadius: '12px', backgroundColor: '#ffffff', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}>
                <h4 style={{ margin: '0 0 16px 0', fontSize: '16px', fontWeight: '600', color: '#334155' }}>Status Breakdown</h4>
                <div className="audit-stats-row2" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
                    <div className="audit-stats-card" style={{ backgroundColor: '#ecfdf5', border: '1px solid #d1fae5' }}>
                        <div className="stats-icon success-bg">
                            <i className="fa fa-check"></i>
                        </div>
                        <div className="stats-content">
                            <div className="stats-label">Success</div>
                            <div className="stats-value">
                                {formatNumber(data.statusCounts?.success)}
                            </div>
                        </div>
                    </div>

                    <div className="audit-stats-card" style={{ backgroundColor: '#fff1f2', border: '1px solid #ffe4e6' }}>
                        <div className="stats-icon danger-bg">
                            <i className="fa fa-times"></i>
                        </div>
                        <div className="stats-content">
                            <div className="stats-label">Failed</div>
                            <div className="stats-value">
                                {formatNumber(data.statusCounts?.failed)}
                            </div>
                        </div>
                    </div>

                    <div className="audit-stats-card" style={{ backgroundColor: '#fefce8', border: '1px solid #fef08a' }}>
                        <div className="stats-icon warning-bg">
                            <i className="fa fa-folder-open"></i>
                        </div>
                        <div className="stats-content">
                            <div className="stats-label">Opened</div>
                            <div className="stats-value">
                                {formatNumber(data.statusCounts?.opened)}
                            </div>
                        </div>
                    </div>

                    <div className="audit-stats-card" style={{ backgroundColor: '#fafafa', border: '1px solid #f4f4f5' }}>
                        <div className="stats-icon secondary-bg">
                            <i className="fa fa-times-circle"></i>
                        </div>
                        <div className="stats-content">
                            <div className="stats-label">Dismissed</div>
                            <div className="stats-value">
                                {formatNumber(data.statusCounts?.dismissed)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeatureStats;
